import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { enReferences, frReferences, nlReferences, deReferences } from "./translation/references";
import { enServices, frServices, nlServices, deServices } from "./translation/services";
import {
  enServicesDropdown,
  frServicesDropdown,
  nlServicesDropdown,
  deServicesDropdown
} from "./translation/servicesDropdown";
import {
  enSolutionsDropdown,
  frSolutionsDropdown,
  nlSolutionsDropdown,
  deSolutionsDropdown
} from "./translation/solutionsDropdown";
import {
  enReferencesDropdown,
  frReferencesDropdown,
  nlReferencesDropdown,
  deReferencesDropdown
} from "./translation/referencesDropdown";
import {
  enMobileAppDevelopment,
  frMobileAppDevelopment,
  nlMobileAppDevelopment,
  deMobileAppDevelopment

} from "./translation/serviceDetails/mobileAppDevelopment";
import {
  enWebDevelopment,
  frWebDevelopment,
  nlWebDevelopment,
  deWebDevelopment
} from "./translation/serviceDetails/webDevelopment";
import {
  enGraphicDesign,
  frGraphicDesign,
  nlGraphicDesign,
  deGraphicDesign
} from "./translation/serviceDetails/graphicDesign";
import { enSEO, frSEO, nlSEO, deSEO } from "./translation/serviceDetails/seo";
import {
  enDigitalTransformation,
  frDigitalTransformation,
  nlDigitalTransformation,
  deDigitalTransformation
} from "./translation/serviceDetails/digitalTransformation";
import {
  enCybersecurity,
  frCybersecurity,
  nlCybersecurity,
  deCybersecurity
} from "./translation/serviceDetails/cybersecurity";
import {
  enCloudDevOps,
  frCloudDevOps,
  nlCloudDevOps,
  deCloudDevOps,
} from "./translation/serviceDetails/cloudDevops";
import {
  enITSupport,
  frITSupport,
  nlITSupport,
  deITSupport
} from "./translation/serviceDetails/itSupport";
import {
  enSocialMedia,
  frSocialMedia,
  nlSocialMedia,
  deSocialMedia
} from "./translation/serviceDetails/socialMedia";
import {
  enFoodDelivery,
  frFoodDelivery,
  nlFoodDelivery,
  deFoodDelivery
} from "./translation/solutionDetails/foodDelivery";
import {
  enMultiVendorEcommerce,
  frMultiVendorEcommerce,
  nlMultiVendorEcommerce,
  deMultiVendorEcommerce
} from "./translation/solutionDetails/ecommerceMultiVendor";
import {
  enLMSMarketplace,
  frLMSMarketplace,
  nlLMSMarketplace,
  deLMSMarketplace
} from "./translation/solutionDetails/lmsMarketplace";
import {
  enHRManagement,
  frHRManagement,
  nlHRManagement,
  deHRManagement
} from "./translation/solutionDetails/hrManagement";
import {
  enSaaSBilling,
  frSaaSBilling,
  nlSaaSBilling,
  deSaaSBilling
} from "./translation/solutionDetails/saasBilling";
import {
  enServiceBooking,
  frServiceBooking,
  nlServiceBooking,
  deServiceBooking
} from "./translation/solutionDetails/serviceBooking";
import {
  enRideSharing,
  frRideSharing,
  nlRideSharing,
  deRideSharing
} from "./translation/solutionDetails/rideSharing";
import {
  enPosSystem,
  frPosSystem,
  nlPosSystem,
  dePosSystem
} from "./translation/solutionDetails/posSystem";
import { enClients, frClients, nlClients, deClients } from "./translation/clients";
import { enPartners, frPartners, nlPartners, dePartners } from "./translation/partners";
import { enApropos, frApropos, nlApropos, deApropos } from "./translation/apropos";
import { enNavbar, frNavbar, nlNavbar, deNavbar } from "./translation/navbar";
import { enHomePropos, frHomePropos, nlHomePropos, deHomePropos } from "./translation/homePropos";
import { enSolutions, frSolutions, nlSolutions, deSolutions } from "./translation/solutions";
import { enValeurs, frValeurs, nlValeurs, deValeurs } from "./translation/valeurs";
import { enFooter, frFooter, nlFooter, deFooter } from "./translation/footer";
import { enTeam, frTeam, nlTeam, deTeam } from "./translation/team";
import { enPortfolio, frPortfolio, nlPortfolio, dePortfolio } from "./translation/portfolio";
import { enChiffres, frChiffres, nlChiffres, deChiffres } from "./translation/Chiffres";
import { enQuote, frQuote, nlQuote, deQuote } from "./translation/quote";

const resources = {
  en: {
    references: enReferences,
    services: enServices,
    servicesDropdown: enServicesDropdown,
    webDevelopment: enWebDevelopment,
    mobileAppDevelopment: enMobileAppDevelopment,
    graphicDesign: enGraphicDesign,
    seo: enSEO,
    digitalTransformation: enDigitalTransformation,
    cybersecurity: enCybersecurity,
    cloudDevOps: enCloudDevOps,
    itSupport: enITSupport,
    socialMedia: enSocialMedia,
    foodDelivery: enFoodDelivery,
    ecommerceMultiVendor: enMultiVendorEcommerce,
    lmsMarketplace: enLMSMarketplace,
    hrManagement: enHRManagement,
    saasBilling: enSaaSBilling,
    serviceBooking: enServiceBooking,
    rideSharing: enRideSharing,
    posSystem: enPosSystem,
    solutionsDropdown: enSolutionsDropdown,
    referencesDropdown: enReferencesDropdown,
    clients: enClients,
    partners: enPartners,
    apropos: enApropos,
    navbar: enNavbar,
    homePropos: enHomePropos,
    solutions: enSolutions,
    valeurs: enValeurs,
    footer: enFooter,
    team: enTeam,
    portfolio: enPortfolio,
    chiffres: enChiffres,
    quote: enQuote,
  },
  fr: {
    references: frReferences,
    solutionsDropdown: frSolutionsDropdown,
    apropos: frApropos,
    homePropos: frHomePropos,
    navbar: frNavbar,
    services: frServices,
    partners: frPartners,
    solutions: frSolutions,
    valeurs: frValeurs,
    servicesDropdown: frServicesDropdown,
    referencesDropdown: frReferencesDropdown,
    ecommerceMultiVendor: frMultiVendorEcommerce,
    foodDelivery: frFoodDelivery,
    lmsMarketplace: frLMSMarketplace,
    hrManagement: frHRManagement,
    saasBilling: frSaaSBilling,
    serviceBooking: frServiceBooking,
    rideSharing: frRideSharing,
    posSystem: frPosSystem,
    clients: frClients,
    webDevelopment: frWebDevelopment,
    mobileAppDevelopment: frMobileAppDevelopment,
    graphicDesign: frGraphicDesign,
    seo: frSEO,
    digitalTransformation: frDigitalTransformation,
    cybersecurity: frCybersecurity,
    cloudDevOps: frCloudDevOps,
    itSupport: frITSupport,
    socialMedia: frSocialMedia,
    footer: frFooter,
    team: frTeam,
    portfolio: frPortfolio,
    chiffres: frChiffres,
    quote: frQuote,
  },

  nl: {
    navbar: nlNavbar,
    apropos: nlApropos,
    portfolio: nlPortfolio,
    clients: nlClients,
    partners: nlPartners,
    cloudDevOps: nlCloudDevOps,
    references: nlReferences,
    services: nlServices,
    servicesDropdown: nlServicesDropdown,
    webDevelopment: nlWebDevelopment,
    mobileAppDevelopment: nlMobileAppDevelopment,
    graphicDesign: nlGraphicDesign,
    seo: nlSEO,
    digitalTransformation: nlDigitalTransformation,
    cybersecurity: nlCybersecurity,
    itSupport: nlITSupport,
    socialMedia: nlSocialMedia,
    foodDelivery: nlFoodDelivery,
    ecommerceMultiVendor: nlMultiVendorEcommerce,
    lmsMarketplace: nlLMSMarketplace,
    hrManagement: nlHRManagement,
    saasBilling: nlSaaSBilling,
    serviceBooking: nlServiceBooking,
    rideSharing: nlRideSharing,
    posSystem: nlPosSystem,
    solutionsDropdown: nlSolutionsDropdown,
    referencesDropdown: nlReferencesDropdown,
    homePropos: nlHomePropos,
    solutions: nlSolutions,
    valeurs: nlValeurs,
    footer: nlFooter,
    team: nlTeam,
    portfolio: nlPortfolio,
    chiffres: nlChiffres,
    quote: nlQuote,
  },

  de:{
    navbar: deNavbar,
    apropos: deApropos,
    portfolio: dePortfolio,
    clients: deClients,
    partners: dePartners,
    cloudDevOps: deCloudDevOps,
    references: deReferences,
    services: deServices,
    servicesDropdown: deServicesDropdown,
    webDevelopment: deWebDevelopment,
    mobileAppDevelopment: deMobileAppDevelopment,
    graphicDesign: deGraphicDesign,
    seo: deSEO,
    digitalTransformation: deDigitalTransformation,
    cybersecurity: deCybersecurity,
    itSupport: deITSupport,
    socialMedia: deSocialMedia,
    foodDelivery: deFoodDelivery,
    ecommerceMultiVendor: deMultiVendorEcommerce,
    lmsMarketplace: deLMSMarketplace,
    hrManagement: deHRManagement,
    saasBilling: deSaaSBilling,
    serviceBooking: deServiceBooking,
    rideSharing: deRideSharing,
    posSystem: dePosSystem,
    solutionsDropdown: deSolutionsDropdown,
    referencesDropdown: deReferencesDropdown,
    homePropos: deHomePropos,
    solutions: deSolutions,
    valeurs: deValeurs,
    footer: deFooter,
    team: deTeam,
    portfolio: dePortfolio,
    chiffres: deChiffres,
    quote: deQuote,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "fr", // default language
  fallbackLng: "fr",
  debug: false,
  detection: {
    order: [], // Disable language detection
  },
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
